import { useUser } from "@/composables/user";
import { redirectToAuth } from "@/router/helpers";
import { createPublicItemDetailLink } from "@/router/linkFactories";
import { getPublicCollectionItemById, PublicItemNotFoundException } from "@/services/collection/item";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const handleItemEditationAccess = async (toRoute: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  await checkUserOnInitialPageLoad();
  const { isUserLoggedIn } = useUser();
  if (isUserLoggedIn.value) {
    return next();
  }

  const itemId = parseInt(toRoute.params.id as string);
  return getPublicCollectionItemById(itemId)
    .then((item) => {
      // Item is public - let's redirect to Public item detail
      const publicItemDetailRoute = createPublicItemDetailLink(item.id, item.name, item.collectorNickname);
      return next(publicItemDetailRoute);
    })
    .catch((e: unknown) => {
      if (e instanceof PublicItemNotFoundException) {
        // Item not public - redirect to login
        return redirectToAuth(toRoute, next);
      } else {
        throw e;
      }
    });
};
